// SUR-R70: earned and custom are two numbers, never one. Ported from
// `apps/mobile/src/accountHome/awardCounts.ts`; the two apps do not share
// source, so this is the single web implementation of the same rule.

export type typeAwardCounts = {
  medalsEarned: number;
  medalsCustom: number;
  trophiesEarned: number;
  trophiesCustom: number;
};

export const ZERO_AWARD_COUNTS: typeAwardCounts = {
  medalsEarned: 0,
  medalsCustom: 0,
  trophiesEarned: 0,
  trophiesCustom: 0,
};

export function awardCountLine(input: {
  earned: number;
  custom: number;
  kind: "medal" | "trophy";
}): string {
  const noun =
    input.kind === "medal"
      ? input.earned === 1
        ? "medal"
        : "medals"
      : input.earned === 1
        ? "trophy"
        : "trophies";
  return `${input.earned} ${noun} · ${input.custom} awarded`;
}

export function medalLine(counts: typeAwardCounts): string {
  return awardCountLine({
    earned: counts.medalsEarned,
    custom: counts.medalsCustom,
    kind: "medal",
  });
}

export function trophyLine(counts: typeAwardCounts): string {
  return awardCountLine({
    earned: counts.trophiesEarned,
    custom: counts.trophiesCustom,
    kind: "trophy",
  });
}
